import { createSelector } from 'reselect';

import { selectThumbnailFlow } from './editor';
import { selectEmojiOrCommentOnBar } from './video';

const selectShareVideo = state => state.share_video;

export const selectVideo = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video
);
export const selectTranscriptSearch = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.transcriptSearch
);
export const selectUserIsOwner = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.current_user_is_owner
);
export const selectVideoBelongsToTeam = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.video_is_team_shared
);
export const selectVideoUseEmojis = createSelector(
  selectVideo,
  video => video.use_emojis
);
export const selectVideoViews = createSelector(
  selectVideo,
  video => video.views
);
export const selectUserCanEditVideo = createSelector(selectShareVideo, video =>
  Boolean(
    video.current_user_is_owner ||
      video.video_is_team_shared ||
      video.video?.collaboratePermissions.write
  )
);
export const selectTranscriptDetails = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.transcript_details
);
export const selectTranscriptPhrases = createSelector(
  selectShareVideo,
  shareVideo => shareVideo.transcript
);
export const selectTranscriptionStatus = createSelector(
  selectTranscriptDetails,
  transcriptDetails => transcriptDetails.transcription_status
);
export const selectIsTranscriptSearchOpen = createSelector(
  selectTranscriptSearch,
  transcriptSearch => transcriptSearch.isTranscriptSearchOpen
);
export const selectTranscriptSearchPhrase = createSelector(
  selectTranscriptSearch,
  transcriptSearch => transcriptSearch.transcriptSearchPhrase
);
export const selectTranscriptSearchInputValue = createSelector(
  selectTranscriptSearch,
  transcriptSearch => transcriptSearch.transcriptSearchInputValue
);
export const selectTranscriptSearchPhraseIndexArray = createSelector(
  selectTranscriptSearch,
  transcriptSearch => transcriptSearch.transcriptSearchPhraseIndexArray
);
export const selectCurrentSearchIndex = createSelector(
  selectTranscriptSearch,
  transcriptSearch => transcriptSearch.currentSearchIndex
);
export const selectRecordingClient = createSelector(
  selectShareVideo,
  videoPlayer => videoPlayer.video.video_properties.recordingClient
);

export const selectCtaEnabled = createSelector(
  selectShareVideo,
  videoPlayer => videoPlayer.cta_enabled
);

export const selectCtaConfig = createSelector(
  selectShareVideo,
  videoPlayer => ({
    ctaMods: videoPlayer.cta_mods,
    ctaUrl: videoPlayer.cta_url,
    ctaText: videoPlayer.cta_text,
  })
);

export const selectDrawSharepageControlBar = createSelector(
  selectEmojiOrCommentOnBar,
  selectThumbnailFlow,
  (emojiOrCommentOnBar, thumbnailFlow) => !thumbnailFlow && emojiOrCommentOnBar
);
